import { defineAbilitiesFor } from './casl-abilities';
import { UserRole, type Action, type Subject } from '@/components/authnz/types/rbac';
import {
  PRODUCTION_ACTIONS,
  PRODUCTION_SUBJECTS,
} from './production-ability-matrix';
import type { PackedRule } from './types';

const PACK_UID = 'access-decision-pack';

function addRule(rules: PackedRule[], action: Action, subject: Subject): void {
  if (rules.some((rule) => rule.action === action && rule.subject === subject)) {
    return;
  }
  rules.push({ action, subject });
}

/**
 * Serialize production CASL abilities into packed Session rules.
 * Source of truth is defineAbilitiesFor — not a hand-maintained parallel map.
 */
export function packRules(roles: readonly UserRole[]): PackedRule[] {
  if (roles.length === 0) {
    return [];
  }

  const ability = defineAbilitiesFor({
    uid: PACK_UID,
    email: 'pack@access.local',
    role: [...roles],
  });

  if (ability.can('manage', 'all')) {
    return [{ action: 'manage', subject: 'all' }];
  }

  const rules: PackedRule[] = [];

  for (const subject of PRODUCTION_SUBJECTS) {
    if (subject === 'all') {
      continue;
    }

    if (ability.can('manage', subject)) {
      addRule(rules, 'manage', subject);
      continue;
    }

    for (const action of PRODUCTION_ACTIONS) {
      if (action === 'manage') {
        continue;
      }
      if (ability.can(action, subject)) {
        addRule(rules, action, subject);
      }
    }
  }

  return rules;
}
